import { render, staticRenderFns } from "./RoleAccessAdd.vue?vue&type=template&id=57760b17&scoped=true&"
import script from "./RoleAccessAdd.vue?vue&type=script&lang=js&"
export * from "./RoleAccessAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57760b17",
  null
  
)

export default component.exports